export enum VISIBILITY_FACTOR {
  CART_EMPTY,
  CART_ACTIVE,
}

export enum Intents {
  greet = '#greet',
  acknowledge = '#acknowledge',
  askRepeat = '#ask-repeat',
  askMoment = '#ask-moment',
  requestStaff = '#request-staff',
  continue = '#continue',
  confirm = '#confirm',
  readback = '#readback',
  complete = '#window',
}

export interface IntentCard {
  intent: Intents;
  title: string;
  description: string;
  color: string;
  textColor?: string;
  cardSize: number;
  disabled?: boolean;
  visibility?: VISIBILITY_FACTOR;
  messages: string[];
}
